export default {
  about: 'About',
  allExperiences: 'All experiences',
  amenities: 'Amenities',
  apply: 'Apply',
  at: 'at',
  avail: 'Availability',
  book: 'Book',
  bookExperience: 'Book Experience',
  by: 'By',
  chooseATime: 'Choose a time for {{title}}',
  dateOfExperience: 'Date of experience',
  details: 'Details',
  durationHour: 'hour',
  durationHours: 'hours',
  durationMinutes: 'min',
  eventSize: 'Event Size',
  experienceCalendar: 'Experience Calendar',
  experienceCancelled: 'Experience Cancelled',
  experienceStartingPrice: 'From {{price}}',
  experienceTotalPrice: 'Total {{price}}',
  featuredExperiences: 'Our Featured Experiences',
  groupSize: 'Group Size',
  hostedBy: 'Hosted By',
  learnMore: 'Learn more',
  location: 'Location',
  maxPartySize: 'Maximum of {{maxGroupSize}} slot per party',
  maxPartySizes: 'Maximum of {{maxGroupSize}} slots per party',
  noAvailability: 'No Availability',
  readLess: 'Read Less',
  readMore: 'Read More',
  reminders: 'Reminders',
  reviewPlural: 'reviews',
  reviewSingular: 'review',
  reviews: 'Reviews',
  searchAll: 'Search All',
  searchAllExperiences: 'Search all Experiences',
  seeMore: 'See More',
  seeOtherDates: 'See other dates',
  select: 'Select',
  selectDateValidation: 'Please select date',
  selectDuration: 'Duration',
  selectParticipantValidation: 'Please select participants',
  selectSession: 'Select Session',
  sessionsCount: '{{count}} times — choose a time',
  selectSessionValidation: 'Please select session',
  selectStartTime: 'Start time',
  slotLeft: '{{remainSlots}} slot left',
  slotsLeft: '{{remainSlots}} slots left',
  spotsLeft: '{{count}} left',
  spotsLeftAriaLabel: '{{count}} spots remaining',
  soldOut: 'Sold Out',
  theFollowingVideoDoesNotContainAnyAudio:
    'The following video does not contain any audio',
  upTo: 'Up to',
  viewPrivateSessAvailability: 'View private session availability',
  whatWeDo: "What We'll Do",
  whatsIncluded: "What's Included",
  whereWeAre: "Where We'll Be",
  ticketSalesOpenIn: 'Ticket sales open in',
  ticketSalesOpen: 'Ticket sales open',
  ticketSalesCloseIn: 'Ticket sales close in',
  ticketSalesClose: 'Ticket sales close',
  ticketSalesClosed: 'Ticket sales closed',
  comingSoon: 'Coming soon',
  inPartnershipWith: 'In partnership with',
  notFoundExperienceTitle: 'This experience is no longer available',
  notFoundExperienceSubtitle:
    'It may have been unpublished, or the link may no longer be valid.',
  deadLinkRecoverySubtitle: 'Discover other experiences available to book',
  viewAllExperiences: 'View All Experiences',
  experienceBenefits: {
    benefits: {
      basePointsEarn:
        '<p><strong>Earn 5 Base Points</strong> per eligible $1 USD spent when signing in to your World of Hyatt account to book this experience</p>',
      basePoints:
        '<p><strong>Earn 10 Base Points</strong> per eligible $1 USD spent when signing in to your World of Hyatt account to book this experience</p>',
      additionalBonusPoints:
        '<p><strong>Earn an additional 4 Bonus Points</strong> per eligible $1 USD spent when you book with your World of Hyatt Credit Card</p>',
      additionalBonusPointsTier:
        '<p><strong>Earn up to 30% additional Bonus Points</strong> depending on your tier status</p>',
      payWithPoints:
        '<p><strong>Pay with Points</strong> when booking this experience</p>',
    },
  },
};
